import { IWorkspace } from "models/IWorkspace";

export interface IAddMemberDialogProps {
  isOpen: boolean;
  onDismiss: (success: boolean, updatedWorkspace?: IWorkspace) => void;
  workspace: IWorkspace;
  canRemoveExisting?: boolean;
}

export const DIALOG_LABELS = {
  TITLE: "Add Member",
  TEAM_MEMBERS: "Team Members",
  EXISTING_MEMBERS: "Existing Members",
  ADD_NEW_MEMBERS: "Add New Members",
  CANCEL: "Cancel",
  SAVE: "Save",
  SAVING: "Saving",
} as const;

export const ERROR_MESSAGES = {
  SAVE_ERROR: "An error occurred while saving. Please try again.",
} as const;

export const PICKER_IDS = {
  TEAM_MEMBERS: "add-member-picker",
} as const;
